import "@/App.css";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";
import AnalyticsTracker from "@/components/AnalyticsTracker";
import CookieConsent from "@/components/CookieConsent";
import Home from "@/pages/Home";
import Contact from "@/pages/Contact";
import FlyGuide from "@/pages/FlyGuide";
import AnalyticsDashboard from "@/pages/AnalyticsDashboard";
import AquaticInsects from "@/pages/guides/AquaticInsects";
import FlyTypes from "@/pages/guides/FlyTypes";
import ReadingWater from "@/pages/guides/ReadingWater";
import FlyBox from "@/pages/guides/FlyBox";
import TermsAndConditions from "@/pages/TermsAndConditions";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import CookiePolicy from "@/pages/CookiePolicy";

function App() {
  return (
    <HelmetProvider>
      <div className="App min-h-screen bg-[#0F1419]">
        <BrowserRouter>
          <ScrollToTop />
          <AnalyticsTracker />
          <Header />
          <main className="pt-20">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/fly-guide" element={<FlyGuide />} />
              <Route path="/guide/aquatic-insects" element={<AquaticInsects />} />
              <Route path="/guide/fly-types" element={<FlyTypes />} />
              <Route path="/guide/reading-water" element={<ReadingWater />} />
              <Route path="/guide/fly-box" element={<FlyBox />} />
              <Route path="/terms" element={<TermsAndConditions />} />
              <Route path="/privacy" element={<PrivacyPolicy />} />
              <Route path="/cookies" element={<CookiePolicy />} />
              <Route path="/analytics" element={<AnalyticsDashboard />} />
            </Routes>
          </main>
          <Footer />
          <CookieConsent />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
